export default __webpack_public_path__ + "static/media/tank_1.13667910.png";